// extracted by mini-css-extract-plugin
export default {"infoCell":"_29OmPdFv2ZXSnJ9cv9A","title":"jBBZS3mQ0a4hZjsHctql","description":"QbWJQzRdg4KDIOCNxTKQ"};